
export const checkCurrentTimeWithTargetTime = (time, date) => {
    const currentTime = new Date();
    const targetTime = new Date(`${date}T${time}`);
    return currentTime < targetTime;
}
